import gql from 'graphql-tag';
import FragmentApplication from 'graphql/fragments/application';

export default gql`
  mutation createApplication($name: String!, $environments: [String]) {
    createApplication(input: { name: $name, environments: $environments }) {
      ...FragmentApplication
    }
  }

  ${FragmentApplication}
`;
